import { Flex } from '@motili/ui';
import MotiliButton from 'common/components-v2/buttons/MotiliButton';
import UploadPhotoRequireButton from 'common/components/document/DocumentRequirementsPhotos/DocumentRequirementsPhotosUploadedRow/UploadPhotoRequireButton';
import { getNotApplicationFiles } from 'common/components/file-upload/FileUploadDropzone';
import { AcceptedFile } from 'common/types/documentRequirements';
import styled from 'styled-components';

const ButtonWrap = styled.div`
   flex: 1;
   height: 36px;

    & button {
        width: 100% !important;
        height: 100% !important;
        padding: 0 !important;
    }
`;
type Props = {
    mode: 'upload' | 'reupload';
    busy?: boolean;
    disabledNotApplicable?: boolean;
    disabledUpload?: boolean;
    handleOnDrop: (
        acceptedFiles: AcceptedFile[],
        rejectedFiles: File[],
        actionType: 'upload' | 'reupload'
    ) => void;
    allowFiles: any;
    notApplicableTestId?: string;
    uploadTestId?: string;
    uploadText?: string;
};

export default function PhotoRequirementActionButtons({
    mode,
    busy = false,
    disabledNotApplicable = false,
    disabledUpload = false,
    handleOnDrop,
    notApplicableTestId,
    uploadTestId,
    uploadText,
    allowFiles,
}: Props) {
    return (
        <Flex direction='row' gap='16px' style={{ width: '100%' }}>
            <ButtonWrap>
                <MotiliButton
                    dataTestId={notApplicableTestId}
                    onClick={() =>
                        handleOnDrop(
                            getNotApplicationFiles() as AcceptedFile[],
                            [],
                            mode
                        )
                    }
                    text='Not Applicable'
                    moStyle='normal'
                    disabled={disabledNotApplicable || busy}
                />
            </ButtonWrap>

            <ButtonWrap>
                <UploadPhotoRequireButton
                    dataTestId={uploadTestId}
                    handleOnDrop={(acceptedFiles, rejectedFiles) =>
                        handleOnDrop(acceptedFiles, rejectedFiles, mode)
                    }
                    disabled={disabledUpload || busy}
                    text={
                        uploadText || (mode === 'reupload' ? 'Re-Upload' : 'Upload')
                    }
                    allowFiles={allowFiles}
                    buttonStyle={{ width: '100%', height: 36, padding: 0 }}
                />
            </ButtonWrap>
        </Flex>
    );
}
